import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { specializationClient } from '../client/specializationClient';

type Options = {
};

const defaultOptions: Partial<Options> = {
};

export const useSpecializations = (params: Specializations.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getSpecializations, params],
    queryFn: () => specializationClient.getSpecializations(params),
  });

  return {
    ...rest,
    count: data?.count || 0,
    specializations: data?.results || [],
  };
};
